import { Skeleton, Typography, TypographyProps } from '@mui/material';
import { FC } from 'react';
import { useTheme } from '~/themes';
import { HeaderSx } from './types';

interface HeaderProps extends TypographyProps<'div'> {
  isLoading?: boolean;
  variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  align?: 'inherit' | 'left' | 'center' | 'right' | 'justify';
  color?: string;
  sx?: HeaderSx;
  skeletonSx?: Pick<TypographyProps<'div'>, 'fontSize' | 'marginY' | 'width'>;
}

const Header: FC<HeaderProps> = ({
  isLoading = false,
  color,
  children,
  variant = 'h1',
  align = 'left',
  sx,
  skeletonSx,
}) => {
  const { COLORS } = useTheme();
  const { marginBottom, alignItems = 'center', fontWeight = 'bold', ...othersSx } = sx ?? {};
  const { fontSize, width = '80%' } = skeletonSx ?? {};

  color = color || COLORS.text.primary;

  return isLoading ? (
    <Skeleton variant='text' sx={{ width, fontSize }} />
  ) : (
    <Typography
      component={'div'}
      variant={variant}
      sx={{
        color,
        marginBottom,
        alignItems,
        fontWeight,
        textAlign: align,
        ...othersSx,
      }}
      align={align}
    >
      {children}
    </Typography>
  );
};

export { Header };
